import { render, staticRenderFns } from "./NotificationPopUp.vue?vue&type=template&id=3512bbad&scoped=true&"
import script from "./NotificationPopUp.vue?vue&type=script&lang=js&"
export * from "./NotificationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopUp.vue?vue&type=style&index=0&id=3512bbad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3512bbad",
  null
  
)

export default component.exports